<div  class="print-history-popup" [formGroup]="roomForm">
    <div class="print-history-popup-body">
      <h2 class="popup-title">
        {{'appointments.gui.buttons.add room' | translate}}
    </h2>
    <div style="overflow: hidden;">
        <div style="width: 70%; float: right;">
            <div class="l-flex l-flex-c t-field t-field-pad">
                <i class="t-sep"></i>
                <input type="text" class="t-field-text w100" formControlName="RoomName" />
                <label style="white-space: nowrap;">
                  {{ 'appointments.gui.labels.room name' | translate | titlecase }}
                </label>
            </div>
            <div class="l-flex l-flex-c t-field t-field-pad" style="gap: 1em; margin-top: 0.5em;">
              <label style="white-space: nowrap;">{{ 'appointments.gui.labels.room type' | translate }}</label>
              <label class="t-label-top py-4">
                <input type="radio" class="custom-check" formControlName="roomType" value="exam" />
                <i class="customInput-display" style="border:1px solid; "></i>
                <span>{{ 'appointments.gui.labels.exam room' | translate }}</span>
              </label>
              <label class="t-label-top py-4">
                <input type="radio" class="custom-check" formControlName="roomType" value="doctor" />
                <i class="customInput-display" style="border:1px solid; "></i>
                <span>{{ 'appointments.gui.labels.doctor room' | translate }}</span>
              </label>
            </div>
            <div class="l-flex l-flex-c t-field t-field-pad" style="gap: 1em; margin-top: 0.5em;">
              <label style="white-space: nowrap;">{{ 'appointments.gui.labels.room schedule type' | translate }}</label>
              <label class="t-label-top py-4">
                <input type="radio" class="custom-check" formControlName="isOneTime" [value]="false" />
                <i class="customInput-display" style="border:1px solid; "></i>
                <span>{{ 'appointments.gui.labels.permanent room' | translate }}</span>
              </label>
              <label class="t-label-top py-4">
                <input type="radio" class="custom-check" formControlName="isOneTime" [value]="true" />
                <i class="customInput-display" style="border:1px solid; "></i>
                <span>{{ 'appointments.gui.labels.one-time room' | translate }}</span>
              </label>
            </div>
            <div *ngIf="roomForm.value.isOneTime" class="l-flex l-flex-c t-field t-field-pad" style="margin-top: 0.5em;">
              <input type="date" class="t-field-text w100" formControlName="oneTimeDate" />
              <label style="white-space: nowrap;">
                {{ 'appointments.gui.labels.Start date' | translate }}
              </label>
            </div>
            <div *ngIf="roomForm.value.isOneTime" class="l-flex l-flex-c t-field t-field-pad" style="margin-top: 0.5em;">
              <input type="date" class="t-field-text w100" formControlName="oneTimeDateTo" />
              <label style="white-space: nowrap;">
                {{ 'appointments.gui.labels.End date' | translate }}
              </label>
            </div>
            <div *ngIf="roomForm.value.isOneTime" class="l-flex l-flex-c t-field t-field-pad" style="margin-top: 0.5em;">
              <select class="t-select w100" formControlName="oneTimeExamType">
                <option [ngValue]="null" disabled>--</option>
                <option *ngFor="let exam of exams" [value]="exam.AutoIndex">
                  {{ getExamName(exam) }}
                </option>
              </select>
              <label style="white-space: nowrap;">
                {{ 'billing.gui.labels.Exam Name' | translate }}
              </label>
            </div>
          <div *ngIf="dateRangeError" style="color:#c0392b; margin-top:0.5em; text-align:right;">{{ dateRangeError }}</div>
          </div>
        <button class="blue-btn" (click)="saveRoom()" >
            {{'appointments.gui.buttons.Save New' | translate}}
        </button>
    </div>
      <button
      (click)="closeRooms()"
        class="print-history-popup-close"
        aria-label="close popup"
      ></button>
    </div>
  </div>